import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img from "../../../images/podcast/ep-1.png";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Banner({data}) {
    return (

        <div className="services_banner ">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="example" data-text="Tek Podcast">
                            <h1>Small Businesses, Big Wins!</h1>
                        </div>
                        <div
                            className="banner_content_txt listing_flex">
                            <p>In the 5th episode of #TechnologyForAChange, our Co-founder and CMO, Abeer Raza, sits down with Jeremy Harbour, Founder of Unity Group and Harbour Club, to discuss his experiences in mergers and acquisitions, how to make a successful exit from a startup, how volatile small businesses are, his goals for next five years, and more</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto text-center">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;